import React from 'react';
import TrialProfileIllustration from '../../assets/trial_profile_illustration.svg';
import { Col, Row } from 'react-bootstrap';
import * as moment from 'moment';
import style from './style.module.scss';
import { SecondaryButton } from '@magoosh/lib/button';
import { paths } from 'config/path_helpers';
import cx from 'classnames';

interface TrialExpirationProps {
  trialExpiredAt?: string;
}

export const TrialExpiration: React.FC<TrialExpirationProps> = (props) => {
  return (
    <>
      <Row>
        <Col sm={4} smOffset={3} className={style.alignOnNonMobile}>
          <h2>
            <strong>Your personalized study plan is waiting!</strong>
          </h2>
          <p>
            Your free trial expired, but we've saved your hard work so you can continue studying right where
            you left off.
          </p>
        </Col>
        <Col sm={2} className="u-margin-T-m text-center">
          <img src={TrialProfileIllustration} alt="GRE student wearing glasses and a bunny hat" />
          {props.trialExpiredAt && (
            <p>
              Trial expired on <br></br>
              <strong>{moment(props.trialExpiredAt).format('DD MMM YYYY')}</strong>
            </p>
          )}
        </Col>
      </Row>
      <Row>
        <Col sm={6} smOffset={3} className={cx(style.purpleList, 'u-margin-T-s u-padding-V-xs')}>
          <h3 className="u-padding-L-xs">
            <strong>Upgrade to Premium now to receive:</strong>
          </h3>
          <ul className="u-padding-L-l">
            <li>Adaptive study recommendations</li>
            <li>Live classes and access to recordings</li>
            <li>Lessons on every topic and strategy</li>
            <li>1750+ test-like questions</li>
            <li>650+ drills and exercises</li>
            <li>Up to three full-length practice tests</li>
            <li>and much more...</li>
          </ul>
        </Col>
      </Row>
      <Row className="u-margin-V-l">
        <Col sm={6} smOffset={3} className={style.alignOnNonMobile}>
          <SecondaryButton href={paths.plans()} block>
            View Premium Plans
          </SecondaryButton>
        </Col>
      </Row>
    </>
  );
};

export default TrialExpiration;
